import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { GetEmployeeAdditionalDetailInterface, CreateEmployeeAdditionalDetailInterface } from "@type/employees.types"
import { additionalDetailDataService } from "services"
import { AppThunk, RootState } from "store"

export interface AdditionalDetailInterface {
	data: null | GetEmployeeAdditionalDetailInterface
	loading: boolean
	saving: boolean
}

const initialState: AdditionalDetailInterface = {
	data: null,
	loading: false,
	saving: false,
}

const detailSlice = createSlice({
	name: "additionalDetail",
	initialState,
	reducers: {
		requestAdditionalDetail: additionalDetail => {
			additionalDetail.loading = true
		},
		receiveAdditionalDetailData: (
			additionalDetail,
			action: PayloadAction<GetEmployeeAdditionalDetailInterface>,
		) => {
			additionalDetail.loading = false
			additionalDetail.data = action.payload
		},
		receiveAdditionalDetailDataFailed: additionalDetail => {
			additionalDetail.loading = false
		},
		requestSavingAdditionalData: additionalDetailData => {
			additionalDetailData.saving = true
		},
		SavingAdditionalData: (additionalDetail, action: PayloadAction<GetEmployeeAdditionalDetailInterface>) => {
			additionalDetail.saving = false
			additionalDetail.data = action.payload
		},
		SavingAdditionalDataFailed: additionalDetail => {
			additionalDetail.saving = false
		},
	},
})

//REDUCER
export default detailSlice.reducer

//ACTIONS
const {
	requestAdditionalDetail,
	receiveAdditionalDetailData,
	receiveAdditionalDetailDataFailed,
	requestSavingAdditionalData,
	SavingAdditionalData,
	SavingAdditionalDataFailed,
} = detailSlice.actions

const getAdditionalDataByEmployeeId =
	(employeeId: string): AppThunk =>
	async dispatch => {
		try {
			dispatch(requestAdditionalDetail())
			const { data: additionalDetailData } =
				await additionalDetailDataService.getEmployeeAdditionalDetailByEmployeeID(employeeId)
			dispatch(receiveAdditionalDetailData(additionalDetailData))
		} catch (error) {
			dispatch(receiveAdditionalDetailDataFailed())
		}
	}

const saveAdditionalDetailData =
	(additionalData: Partial<GetEmployeeAdditionalDetailInterface>): AppThunk =>
	async dispatch => {
		let data = null
		try {
			dispatch(requestSavingAdditionalData())
			if (additionalData._id) {
				data = await additionalDetailDataService.updateEmployeeAdditionalDetailByEmployeeId(
					additionalData._id as string,
					additionalData as GetEmployeeAdditionalDetailInterface,
				)
			} else {
				data = await additionalDetailDataService.createEmployeeAdditionalDetail(
					additionalData as CreateEmployeeAdditionalDetailInterface,
				)
			}
			const { data: additionalDetailData } = data
			dispatch(SavingAdditionalData(additionalDetailData))
		} catch (error) {
			dispatch(SavingAdditionalDataFailed())
		}
	}

export { getAdditionalDataByEmployeeId, saveAdditionalDetailData }

//SELECTORS
const selectEmployeeAdditionalDetail = (state: RootState) => state.employee.additionalDetail
const selectAdditionalDetailLoading = () => (state: RootState) => selectEmployeeAdditionalDetail(state).loading
const selectAdditionalDetailData = () => (state: RootState) => selectEmployeeAdditionalDetail(state).data
const selectAdditionalDetailSaving = () => (state: RootState) => selectEmployeeAdditionalDetail(state).saving

export {
	selectAdditionalDetailData,
	selectEmployeeAdditionalDetail,
	selectAdditionalDetailSaving,
	selectAdditionalDetailLoading,
}
